import React, { useEffect } from "react";

import NavBar from "../components/common/NavBar";
import Footer from "../components/common/Footer";
import Logo from "../components/common/Logo";
import Socials from "../components/common/Socials";

import INFO from "../data/user";

import "./styles/about.css";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="page-content">
        <NavBar active="about" />
        <div className="content-wrapper">
          <div className="about-logo-container">
            <div className="about-logo">
              <Logo width={40} />
            </div>
          </div>

          <div className="about-container">
            <div className="about-main">
              <div className="about-left-side">
                <h1 className="title about-title">{INFO.about.title}</h1>

                <p className="subtitle about-subtitle">
                  {INFO.about.description}
                </p>
                <p className="subtitle about-subtitle">{INFO.about.journey}</p>
                {INFO.about.fact.map((f, index) => (
                  <p className="subtitle about-subtitle" key={index}>
                    {f}
                  </p>
                ))}
              </div>

              <div className="about-right-side">
                <div className="about-image-container">
                  <div className="about-image-wrapper">
                    <img
                      src={require("../assets/about.jpg")}
                      alt="Akash Dandriyal"
                      className="about-image"
                    />
                  </div>
                </div>
                <div className="about-socials">
                  <Socials />
                </div>
              </div>
            </div>
          </div>
          <div className="page-footer">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default About;
